export default {
    language: "বাংলা",
    StripeSuccess: {
        loading: "আপনার পেমেন্ট প্রক্রিয়া করা হচ্ছে...",
        successMessage: "আপনার সাবস্ক্রিপশন সফলভাবে সক্রিয় করা হয়েছে!",
        processingError: "পেমেন্ট প্রক্রিয়াকরণ ব্যর্থ হয়েছে, আমাদের সাথে যোগাযোগ করুন",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "ইমেইল",
            createdAt: "তৈরির তারিখ",
            noRecord: "কোনো রেকর্ড নেই",
            loginTime: "লগইন সময়",
        },
        orders: {
            title: "অর্ডার ইতিহাস",
            loading: "লোড হচ্ছে...",
            refresh: "রিফ্রেশ",
            orderAmount: "পরিমাণ",
            points: "পয়েন্ট",
            createdAt: "তৈরির তারিখ",
            orderType: "ধরন",
            status: "অবস্থা",
            noOrders: "কোনো অর্ডার নেই",
            goToSubscription: "পয়েন্ট কিনুন",
            freeCredit: "ফ্রি ক্রেডিট",
            paidCredit: "পেইড ক্রেডিট",
            queryOrderFailed: "অর্ডার কোয়েরি করতে ব্যর্থ",
            statusPaid: "পরিশোধিত",
            statusPending: "অপেক্ষমান",
            statusCancelled: "বাতিল করা হয়েছে",
            statusDeactivated: "নিষ্ক্রিয় করা হয়েছে",
            checkoutUrlNotAvailable: "চেকআউট URL পাওয়া যায়নি",
            verifyingPayment: "পেমেন্ট যাচাই করা হচ্ছে...",
            paymentSuccess: "পেমেন্ট সফল",
            paymentPending: "অর্ডার পেমেন্ট অপেক্ষারত, অনুগ্রহ করে পেমেন্ট সম্পূর্ণ করুন",
            paymentFailed: "পেমেন্ট ব্যর্থ হয়েছে বা বাতিল করা হয়েছে",
            paymentStatus: "পেমেন্ট অবস্থা",
            paymentStatusDescription: "আপনি কি পেমেন্ট সম্পূর্ণ করেছেন?",
            cancelPayment: "পেমেন্ট বাতিল করুন",
            completedPayment: "পেমেন্ট সম্পন্ন হয়েছে",
            warning: "সতর্কতা",
            confirmCancelOrder: "আপনি কি নিশ্চিত যে আপনি এই অর্ডার বাতিল করতে চান? এই ক্রিয়া পূর্বাবস্থায় ফেরানো যাবে না।",
            cancel: "বাতিল করুন",
            confirm: "নিশ্চিত করুন",
            cancellingOrder: "অর্ডার বাতিল করা হচ্ছে...",
            orderCancelledSuccess: "অর্ডার বাতিল করা হয়েছে",
            cancelOrderFailed: "অর্ডার বাতিল করতে ব্যর্থ",
            checkOrderStatusFailed: "অর্ডার স্ট্যাটাস চেক করতে ব্যর্থ",
            promptClick: "পেমেন্ট চালিয়ে যেতে \"অপেক্ষমান\" স্ট্যাটাসে ক্লিক করুন",
        }
    },
    Order: {
        purchasePoints: "পয়েন্ট কিনুন",
        subtitle: "উচ্চ মানের ওয়াটারমার্ক অপসারণ সেবা উপভোগ করতে উপযুক্ত পয়েন্ট প্যাকেজ চয়ন করুন",
        loginReminderDesc: "পয়েন্ট নির্বাচন ও ক্রয় করতে লগইন করুন",
        freeTag: "ফ্রি",
        freePlan: "ফ্রি প্ল্যান",
        autoActivated: "লগইনের পরে স্বয়ংক্রিয়ভাবে সক্রিয়",
        points: "পয়েন্ট",
        autoIncluded: "ফ্রি উপহার",
        discount: "ছাড়",
        purchase: "এখনই কিনুন",
        paymentStatusDescription: "আপনি কি পেমেন্ট সম্পূর্ণ করেছেন?",
        paymentNotCompleted: "পেমেন্ট অসম্পূর্ণ",
        queryOrderFailed: "অর্ডার স্টেটাস জানতে ব্যর্থ",
        cancelPayment: "পেমেন্ট বাতিল করুন",
        completedPayment: "পেমেন্ট সম্পন্ন",
        warning: "সতর্কতা",
        confirmCancelOrder: "আপনি কি নিশ্চিত যে আপনি এই অর্ডার বাতিল করতে চান? এই ক্রিয়া পূর্বাবস্থায় ফেরানো যাবে না।",
        cancel: "বাতিল",
        confirm: "নিশ্চিত",
        selectProductFirst: "দয়া করে প্রথমে একটি প্যাকেজ নির্বাচন করুন",
        creatingOrder: "অর্ডার তৈরি করা হচ্ছে...",
        orderCreated: "অর্ডার সফলভাবে তৈরি করা হয়েছে",
        createOrderFailed: "অর্ডার তৈরি করতে ব্যর্থ",
        checkoutUrlNotAvailable: "পেমেন্ট লিঙ্ক পেতে ব্যর্থ",
        cancellingOrder: "অর্ডার বাতিল করা হচ্ছে...",
        orderCancelledSuccess: "অর্ডার বাতিল করা হয়েছে",
        cancelOrderFailed: "অর্ডার বাতিল করতে ব্যর্থ",
        verifyingPayment: "পেমেন্ট স্ট্যাটাস যাচাই করা হচ্ছে...",
        paymentSuccess: "পেমেন্ট সফল",
        paymentPending: "অর্ডার পেমেন্ট অপেক্ষমান, দয়া করে পেমেন্ট সম্পন্ন করুন",
        paymentFailed: "পেমেন্ট ব্যর্থ বা বাতিল",
        checkOrderStatusFailed: "অর্ডার স্ট্যাটাস চেক করতে ব্যর্থ",
        quickStart: "দ্রুত শুরু",
        shortTerm: "অল্প সময়ের ব্যবহার",
        recommended: "সুপারিশকৃত",
        bestValue: "সেরা মূল্য",
    },
    Login: {
        title: "লগইন",
        subtitle: "সোশ্যাল অ্যাকাউন্ট দিয়ে দ্রুত লগইন",
        memberTip: "আরও বৈশিষ্ট্য অ্যাক্সেস করতে লগইন করুন",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "GitHub অ্যাকাউন্ট দিয়ে লগইন করুন"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Google অ্যাকাউন্ট দিয়ে লগইন করুন"
            }
        ],
        error: {
            serverError: "সার্ভার ত্রুটি, পরে আবার চেষ্টা করুন",
            networkError: "নেটওয়ার্ক ত্রুটি, আপনার সংযোগ চেক করুন"
        }
    },
    OAuthCallback: {
        loading: "লগইন অনুরোধ প্রক্রিয়া করা হচ্ছে",
        pleaseWait: "অনুগ্রহ করে অপেক্ষা করুন, লগইন তথ্য যাচাই করা হচ্ছে...",
        error: "লগইন ব্যর্থ",
        backToHome: "হোমে ফিরে যান",
        success: "লগইন সফল",
        redirecting: "হোমপেজে রিডাইরেক্ট করা হচ্ছে..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "মূল্য",
            faq: "প্রশ্নসমূহ",
        },
        login: "লগইন",
        userMenu: {
            account: "অ্যাকাউন্ট",
            logout: "লগআউট",
            credit: "ক্রেডিট",
            freeCredit: "ফ্রি",
            paidCredit: "কেনা",
            nextUpdate: "পরবর্তী ক্রেডিট আপডেট",
            language: "ভাষা",
            theme: "থিম",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "ClixMagicAI এর বৈশিষ্ট্য",
        advs: [
            {
                title: "AI স্বয়ংক্রিয় সনাক্তকরণ ইঞ্জিন: বিভিন্ন হস্তক্ষেপকারী উপাদানগুলি স্বয়ংক্রিয়ভাবে চিহ্নিত করে",
                desc: "ডিপ লার্নিং অ্যালগরিদমের উপর ভিত্তি করে, এটি ছবি/ভিডিওতে ওয়াটারমার্ক, টেক্সট, মুখ এবং জটিল পটভূমি উপাদান স্বয়ংক্রিয়ভাবে সনাক্ত করে, ম্যানুয়াল মার্কিং প্রয়োজন ছাড়াই। ইনস্টাগ্রাম, টিকটক ইত্যাদি প্ল্যাটফর্ম ফরম্যাট সমর্থন করে, গোপনীয়তা ডেটা কঠোরভাবে সুরক্ষিত রাখে।",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "ওয়াটারমার্ক অপসারণ করুন"
            },
            {
                title: "ছবি পরিষ্কারক মাস্টার: লোগো/তারিখ স্ট্যাম্প দ্রুত অপসারণ করে, ইমেজ কোয়ালিটি অক্ষত রাখে",
                desc: "ব্র্যান্ড ওয়াটারমার্ক, শুটিং তারিখ, স্টিকার ইত্যাদি নিখুঁতভাবে মুছে ফেলে। AI স্বয়ংক্রিয়ভাবে পটভূমি টেক্সচার পুনরুদ্ধার করে, প্রক্রিয়াকরণের পরে ছবিগুলি মূল ছবির মতোই প্রাকৃতিক, সোশ্যাল মিডিয়া পোস্টিং প্রয়োজনের জন্য নিখুঁত।",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "ওয়াটারমার্ক অপসারণ করুন"
            },
            {
                title: "গতিশীল ওয়াটারমার্ক সমাধান: স্ক্রোলিং সাবটাইটেল/প্ল্যাটফর্ম লোগো মুছুন",
                desc: "ইউটিউব আউটট্রো ব্যানার, টিকটক গতিশীল ওয়াটারমার্ক এবং স্ক্রোলিং টেক্সট এক ক্লিকে অপসারণ করুন। AI স্মার্ট ট্র্যাকিং প্রতিটি ফ্রেম প্রসেস করে, সুন্দর 4K উচ্চ মানের ভিডিও আউটপুট দেয়, MP4/MOV সহ বিভিন্ন ফরম্যাট সমর্থন করে।",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "ওয়াটারমার্ক অপসারণ করুন"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "একটি পেশাদার AI-চালিত ওয়াটারমার্ক অপসারণ টুল যা সহজ অপারেশন এবং প্রাকৃতিক ফলাফল সহ ছবি ও ভিডিও-এ ওয়াটারমার্ক দ্রুত প্রক্রিয়া করে।",
        fileTypes: {
            image: 'ছবি ওয়াটারমার্ক অপসারণ',
            pdf: 'PDF ওয়াটারমার্ক অপসারণ',
            video: 'ভিডিও ওয়াটারমার্ক অপসারণ'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "দৈনিক ফ্রি ট্রায়াল", icon: "fa-gift" },
            { id: "imageTag", text: "ছবি ওয়াটারমার্ক অপসারণ", icon: "fa-image" },
            { id: "videoTag", text: "ভিডিও ওয়াটারমার্ক অপসারণ", icon: "fa-video" },
            { id: "aiPoweredTag", text: "AI-চালিত", icon: "fa-robot" },
            { id: "noRegTag", text: "লগইন এবং ব্যবহার", icon: "fa-user-check" },
        ],
        videoPromt: "শীঘ্রই আসছে!",
        videoDesc: "আমরা আপনাকে আরও শক্তিশালী অভিজ্ঞতা দেওয়ার জন্য ভিডিও ওয়াটারমার্ক অপসারণ বিকাশ করছি।"
    },
    Footer: {
        social: {
            title: "যোগাযোগ করুন",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "আইনি শর্তাবলী",
        terms: [
            {
                id: 1,
                title: "গোপনীয়তা নীতি",
                link: "/privacy"
            },
            {
                id: 2,
                title: "পরিষেবার শর্তাবলী",
                link: "/terms"
            },
            {
                id: 3,
                title: "কুকি নীতি",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI সর্বস্বত্ব সংরক্ষিত।"
    },
    Task: {
        image: {
            imageSupportText: 'jpg, jpeg, png, webp, heic, heif ফরম্যাট সমর্থন করে, প্রতি ফাইল সর্বোচ্চ 10MB',
            imageFileTooLarge: 'ফাইলের আকার সীমা অতিক্রম করেছে (সর্বোচ্চ 10MB)',
            invalidImageType: 'অসমর্থিত ছবির ফরম্যাট, অনুগ্রহ করে JPG, JPEG, PNG, WEBP, HEIC বা HEIF আপলোড করুন',
            imageWillCost: 'খরচ হবে: 1 ক্রেডিট',
            hiecSupportText: 'HEIC/HEIF ফরম্যাট জমা দেওয়ার সময় স্বয়ংক্রিয়ভাবে PNG-তে রূপান্তরিত হবে',
            hiecSuccess: 'HEIC/HEIF ফরম্যাট রূপান্তর সফল',
            hiecFailed: 'HEIC/HEIF ফরম্যাট রূপান্তর ব্যর্থ',
            processingImageTip: 'আপনার ছবি প্রক্রিয়া করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
            guide: {
                title: 'ব্যবহারকারী গাইড',
                step1: 'ছবি আপলোড করুন',
                step2: 'ওয়াটারমার্ক এরিয়ায় পেইন্ট করুন বা মডেলকে স্বয়ংক্রিয়ভাবে সনাক্ত করতে দিন',
                step3: 'সাবমিট ক্লিক করুন'
            }
        },
        common: {
            remaining: 'অবশিষ্ট ক্রেডিট',
            nextUpdate: 'পরবর্তী ক্রেডিট আপডেট',
            handleError: 'ফাইল প্রক্রিয়াকরণে ত্রুটি, অন্য ফাইল চেষ্টা করুন',
            uploadFailed: 'ফাইল আপলোড ব্যর্থ',
            dragText: 'এখানে ফাইল টেনে আনুন অথবা',
            clickText: 'আপলোড করতে ক্লিক করুন',
            loginRequired: 'ফাইল আপলোড করার আগে লগইন করুন',
            noRemainingTasks: 'আপনি আপনার সমস্ত ক্রেডিট ব্যবহার করেছেন',
            loginNow: 'এখন লগইন করুন',
            upgradeNow: 'এখন ক্রেডিট কিনুন',
            taskSubmitSuccess: 'টাস্ক সফলভাবে জমা দেওয়া হয়েছে',
            taskSubmitError: 'টাস্ক জমা দেওয়া ব্যর্থ',
            taskRetrySuccess: 'টাস্ক পুনরায় চেষ্টা সফলভাবে জমা দেওয়া হয়েছে!',
            taskRetryError: 'টাস্ক পুনরায় চেষ্টা জমা দেওয়া ব্যর্থ!',
            processing: 'প্রক্রিয়াকরণ',
            submit: 'জমা দিন',
            waiting: 'অপেক্ষমান',
            completed: 'সম্পূর্ণ',
            failed: 'ব্যর্থ',
            cancelled: 'বাতিল',
            url_not_found: 'লিঙ্ক পেতে ব্যর্থ',
            deleted: 'মুছে ফেলা হয়েছে',
            refreshSuccess: 'টাস্ক তালিকা রিফ্রেশ করা হয়েছে',
            refreshFailed: 'টাস্ক তালিকা রিফ্রেশ করতে ব্যর্থ',
            deleteSuccess: 'টাস্ক সফলভাবে মুছে ফেলা হয়েছে',
            deleteFailed: 'টাস্ক মুছতে ব্যর্থ',
            waitingForCompletion: 'পুনরায় চেষ্টা করার আগে বর্তমান টাস্ক সম্পূর্ণ হওয়ার জন্য অপেক্ষা করুন',
            loadOriginalImageFailed: 'আসল ছবি লোড করতে ব্যর্থ, পুনরায় চেষ্টা করুন',
            downloadFailed: 'ডাউনলোড ব্যর্থ',
            startingDownload: 'ডাউনলোড শুরু হচ্ছে...',
            noTasks: 'কোন টাস্ক নেই',
            refresh: 'রিফ্রেশ',
            sort: 'সাজান',
            noFilterTasks: 'কোন {filter} টাস্ক নেই',
            compare: 'তুলনা দেখুন',
            originalImage: 'আসল',
            processedImage: 'প্রক্রিয়াজাত',
            dragToCompare: '👈 তুলনা করতে টেনে আনুন 👉',
            cancel: "বাতিল",
            delete: "মুছুন",
            retry: "পুনরায় চেষ্টা করুন",
            download: "ডাউনলোড",
            createAt: "তৈরি করা হয়েছে",
            expiredAt: "মেয়াদ শেষ",
        },
        video: {
            videoSupportText: 'mp4, mov, avi, mkv ফরম্যাট সমর্থন করে, প্রতি ফাইল সর্বোচ্চ 100MB',
            videoFileTooLarge: 'ফাইলের আকার সীমা অতিক্রম করেছে (সর্বোচ্চ 100MB)',
            invalidVideoType: 'অসমর্থিত ভিডিও ফরম্যাট, অনুগ্রহ করে MP4, MOV, AVI বা MKV আপলোড করুন',
            videoWillCost: 'খরচ হবে: 3 ক্রেডিট',
            processingVideoTip: 'আপনার ভিডিও প্রক্রিয়া করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
            guide: {
                step1: 'ভিডিও আপলোড করুন',
                step2: 'ওয়াটারমার্ক টাইপ নির্বাচন করুন এবং ওয়াটারমার্ক এরিয়া নির্ধারণ করুন',
                step3: 'সাবমিট ক্লিক করুন'
            },
            annotationTools: 'ওয়াটারমার্ক অ্যানোটেশন টুলস',
            selectType: 'ওয়াটারমার্ক টাইপ নির্বাচন করুন',
            deleteAnnotation: 'অ্যানোটেশন মুছুন',
            clearAllAnnotations: 'সব অ্যানোটেশন মুছুন',
            annotationHelp: 'অ্যানোটেশন সাহায্য',
            dragTip: 'ওয়াটারমার্ক এরিয়া আঁকতে টেনে আনুন',
            resizeTip: 'ওয়াটারমার্কের সাথে মিলাতে আকার পরিবর্তন করুন',
            moveTip: 'তৈরি করা অ্যানোটেশন সরানো যাবে',
            processing: 'প্রক্রিয়াকরণ',
            submit: 'জমা দিন',
            taskSubmitSuccess: 'টাস্ক সফলভাবে জমা দেওয়া হয়েছে',
            taskSubmitError: 'টাস্ক জমা দেওয়া ব্যর্থ',
            retryTaskTip: 'টাস্ক পুনরায় চেষ্টা সফল',
            retryFailed: 'টাস্ক পুনরায় চেষ্টা ব্যর্থ',
            uploadFailed: 'আপলোড ব্যর্থ',
            staticWatermarkDesc: 'স্থির অবস্থানে স্থির ওয়াটারমার্কের জন্য',
            normalWatermarkDesc: 'সাধারণ স্থির ওয়াটারমার্কের জন্য',
            dynamicWatermarkDesc: 'পরিবর্তনশীল গতিশীল ওয়াটারমার্কের জন্য',
            moveWatermarkDesc: 'সরানো প্রয়োজন এমন ওয়াটারমার্কের জন্য'
        },
    },
    Router: {
        home: "হোম",
        terms: "সেবার শর্তাবলী",
        privacy: "গোপনীয়তা নীতি",
        cookie: "কুকি নীতি",
        user: "ব্যবহারকারী কেন্দ্র",
    },
    Terms: {
        "tabs": {
            "terms": "সেবার শর্তাবলী",
            "privacy": "গোপনীয়তা নীতি",
            "cookies": "কুকি নীতি"
        },
        "lastUpdated": "সর্বশেষ আপডেট: মে ২০, ২০২৫",
        "terms": {
            "sections": [
                {
                    "title": "১. ভূমিকা",
                    "description": "ClixMagicAI-এ আপনার স্বাগতম। আমাদের পরিষেবা ব্যবহার করে, আপনি এই সেবার শর্তাবলী মেনে নিচ্ছেন। অনুগ্রহ করে মনোযোগ সহকারে পড়ুন।"
                },
                {
                    "title": "২. পরিষেবার বিবরণ",
                    "description": "ClixMagicAI ছবি ও ভিডিও থেকে ওয়াটারমার্ক অপসারণের জন্য AI-চালিত টুল প্রদান করে। আমাদের পরিষেবা নিম্নলিখিত আইনি ব্যবহারের জন্য উপযুক্ত:",
                    "items": [
                        "আপনার নিজের কন্টেন্ট থেকে ওয়াটারমার্ক অপসারণ",
                        "এমন কন্টেন্ট থেকে ওয়াটারমার্ক অপসারণ যার সংশোধনের জন্য আপনার যথাযথ অধিকার আছে",
                        "শিক্ষামূলক এবং গবেষণার উদ্দেশ্যে"
                    ]
                },
                {
                    "title": "৩. ব্যবহারকারীর দায়িত্ব",
                    "description": "ClixMagicAI ব্যবহার করে, আপনি সম্মত হচ্ছেন যে:",
                    "items": [
                        "শুধুমাত্র আপনার মালিকানাধীন বা সংশোধনের যথাযথ অধিকার আছে এমন কন্টেন্ট আপলোড করবেন",
                        "আমাদের পরিষেবা কোনো অবৈধ উদ্দেশ্যে বা কোনো আইন লঙ্ঘন করে ব্যবহার করবেন না",
                        "আমাদের নিরাপত্তা ব্যবস্থা বা ব্যবহারের সীমাবদ্ধতা এড়িয়ে যাওয়ার চেষ্টা করবেন না",
                        "অন্যের মেধাসম্পত্তি অধিকার লঙ্ঘন করতে আমাদের পরিষেবা ব্যবহার করবেন না"
                    ]
                },
                {
                    "title": "৪. অ্যাকাউন্ট শর্তাবলী",
                    "description": "আমাদের কিছু পরিষেবা ব্যবহার করতে আপনাকে একটি অ্যাকাউন্ট তৈরি করতে হতে পারে। লগইন করতে, আপনি Google বা GitHub অ্যাকাউন্ট ব্যবহার করতে পারেন। আপনি দায়ী থাকবেন:",
                    "items": [
                        "আপনার অ্যাকাউন্টের নিরাপত্তা বজায় রাখার জন্য",
                        "আপনার অ্যাকাউন্টের অধীনে ঘটে যাওয়া সমস্ত কার্যকলাপের জন্য",
                        "সঠিক অ্যাকাউন্ট তথ্য প্রদান করার জন্য (অবতার, ইমেল, ব্যবহারকারীর নাম এবং ব্যবহারকারীর আইডি সহ)"
                    ]
                },
                {
                    "title": "৫. ফ্রি এবং পেইড পরিষেবা",
                    "description": "ClixMagicAI আমাদের ওয়াটারমার্ক অপসারণ বৈশিষ্ট্যগুলিতে অ্যাক্সেসের জন্য ফ্রি বেসিক কোটা এবং নমনীয় পয়েন্ট ক্রয় বিকল্প প্রদান করে:",
                    "items": [
                        "বেসিক কোটা: প্রতিটি ব্যবহারকারী প্রতিদিন স্বয়ংক্রিয়ভাবে ১০টি ফ্রি পয়েন্ট পাবেন, যা কন্টেন্ট প্রসেসিং-এ ব্যবহার করা যাবে",
                        "পয়েন্ট ব্যবহারের নিয়ম: ছবি ওয়াটারমার্ক অপসারণ প্রতি অপারেশনে ১ পয়েন্ট, ভিডিও ওয়াটারমার্ক অপসারণ প্রতি অপারেশনে ৩ পয়েন্ট খরচ করে",
                        "পয়েন্ট ক্রয়: আরও ব্যবহারের জন্য আপনি পয়েন্ট প্যাকেজ কিনতে পারেন, কেনা সমস্ত পয়েন্ট স্থায়ীভাবে বৈধ, কোনো মেয়াদ শেষের সীমাবদ্ধতা ছাড়া",
                        "রিফান্ড নীতি: ডিজিটাল পরিষেবার তাৎক্ষণিক এবং ভার্চুয়াল প্রকৃতির কারণে, একবার সফলভাবে ক্রয় করা পয়েন্ট ফেরত দেওয়া যাবে না"
                    ]
                },
                {
                    "title": "৬. মেধাসম্পত্তি অধিকার",
                    "description": "ClixMagicAI পরিষেবা, আমাদের দ্বারা তৈরি করা সমস্ত সফ্টওয়্যার, ডিজাইন এবং কন্টেন্ট সহ, আমাদের মেধাসম্পত্তি। অনুমতি ছাড়া আপনি আমাদের পরিষেবার উপর ভিত্তি করে কপি, সংশোধন বা ব্যুৎপন্ন কাজ তৈরি করতে পারবেন না।"
                },
                {
                    "title": "৭. দায়বদ্ধতার সীমাবদ্ধতা",
                    "description": "ClixMagicAI পরিষেবা \"যেমন আছে\" প্রদান করে, কোনো ধরনের ওয়ারেন্টি ছাড়া। আমাদের পরিষেবা ব্যবহার করে আপনার হওয়া কোনো ক্ষতির জন্য আমরা দায়ী নই।"
                },
                {
                    "title": "৮. শর্তাবলীর পরিবর্তন",
                    "description": "আমরা যেকোনো সময় এই শর্তাবলী সংশোধন করতে পারি। শর্তাবলী পরিবর্তনের পরে ClixMagicAI ব্যবহার চালিয়ে যাওয়া মানে আপনি সংশোধিত শর্তাবলী গ্রহণ করেছেন।"
                },
                {
                    "title": "৯. সমাপ্তি",
                    "description": "যদি আমরা বিশ্বাস করি যে আপনার আচরণ এই শর্তাবলী লঙ্ঘন করে বা অন্য ব্যবহারকারী, আমাদের বা তৃতীয় পক্ষের ক্ষতি করে, তাহলে আমরা পূর্ব নোটিশ ছাড়াই আমাদের পরিষেবাতে আপনার অ্যাক্সেস অবিলম্বে বন্ধ বা স্থগিত করার অধিকার সংরক্ষণ করি।"
                },
                {
                    "title": "১০. প্রযোজ্য আইন",
                    "description": "এই শর্তাবলী আমাদের কোম্পানির নিবন্ধিত স্থানের প্রযোজ্য আইন দ্বারা নিয়ন্ত্রিত হবে, আইনের সংঘাত বিধান বিবেচনা ছাড়া।"
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "১. ভূমিকা",
                    "description": "ClixMagicAI-এ, আমরা আপনার গোপনীয়তাকে মূল্য দেই এবং আপনার ব্যক্তিগত ডেটা সুরক্ষিত রাখতে প্রতিশ্রুতিবদ্ধ। এই গোপনীয়তা নীতি ব্যাখ্যা করে যে আপনি আমাদের ওয়েবসাইট এবং পরিষেবা ব্যবহার করার সময় আমরা কীভাবে আপনার তথ্য সংগ্রহ, ব্যবহার এবং সুরক্ষা করি। আমাদের ওয়েবসাইট অ্যাক্সেস করে বা যেকোনো পরিষেবা ব্যবহার করে, আপনি এই নীতিতে বর্ণিত ডেটা প্রসেসিং পদ্ধতি গ্রহণ করছইন। আমরা প্রযোজ্য ডেটা সুরক্ষা প্রবিধান মেনে চলি।"
                },
                {
                    "title": "২. আমরা যে তথ্য সংগ্রহ করি",
                    "description": "আমরা নিম্নলিখিত ধরনের তথ্য সংগ্রহ করতে পারি:",
                    "items": [
                        { "bold": "অ্যাকাউন্ট তথ্য", "text": "Google বা GitHub দিয়ে লগইন করার সময় প্রদত্ত ব্যবহারকারীর অবতার, ইমেল ঠিকানা, ব্যবহারকারীর নাম এবং ব্যবহারকারীর আইডি" },
                        { "bold": "ব্যবহারের ডেটা", "text": "আপনি কীভাবে আমাদের পরিষেবা ব্যবহার করিন সে সম্পর্কে তথ্য, অ্যাক্সেস করা বৈশিষ্ট্য এবং ব্যবহারের সময় সহ" },
                        { "bold": "আপলোড করা কন্টেন্ট", "text": "আপনি প্রসেসিং-এর জন্য আপলোড করা ছবি বা ভিডিও" },
                        { "bold": "পেমেন্ট তথ্য", "text": "সাবস্ক্রিপশন কেনার সময় পেমেন্ট তথ্য (Creem/Stripe/PayPal ইত্যাদি তৃতীয় পক্ষের পেমেন্ট গেটওয়ে দ্বারা নিরাপদে প্রসেস করা হয়, আমরা শুধুমাত্র পেমেন্ট স্ট্যাটাস রেকর্ড রাখি)" },
                        { "bold": "প্রযুক্তিগত ডেটা", "text": "IP ঠিকানা, ব্রাউজার ধরন, ডিভাইস তথ্য" }
                    ]
                },
                {
                    "title": "৩. আমরা কীভাবে আপনার তথ্য ব্যবহার করি",
                    "description": "আমরা আপনার তথ্য ব্যবহার করি:",
                    "items": [
                        { "text": "আমাদের পরিষেবা প্রদান, রক্ষণাবেক্ষণ এবং উন্নত করতে" },
                        { "text": "লেনদেন প্রসেস এবং সম্পূর্ণ করতে" },
                        { "text": "প্রযুক্তিগত বিজ্ঞপ্তি এবং সমর্থন বার্তা পাঠাতে" },
                        { "text": "আপনার মন্তব্য এবং প্রশ্নের উত্তর দিতে" },
                        { "text": "ব্যবহারকারী অভিজ্ঞতা বাড়াতে ব্যবহারের প্যাটার্ন বিশ্লেষণ করতে, এবং পরিষেবার উদ্দেশ্য অর্জনের জন্য প্রয়োজনীয় পরিমাণেই ব্যক্তিগত ডেটা প্রসেস করতে" },
                        { "text": "নিশ্চিত করতে যে ব্যক্তিগত ডেটার সংরক্ষণ সময়কাল প্রয়োজনীয় সময়ের বেশি না হয়" },
                        { "text": "প্রতারণা বা অবৈধ কার্যকলাপ প্রতিরোধ করতে" }
                    ]
                },
                {
                    "title": "৪. ডেটা নিরাপত্তা",
                    "description": "আমরা আপনার ব্যক্তিগত তথ্য সুরক্ষিত রাখতে শিল্প-মান সম্মত নিরাপত্তা ব্যবস্থা বাস্তবায়ন করি:",
                    "items": [
                        { "text": "ট্রান্সমিশন এবং স্টোরেজে AES-256 এনক্রিপশন করা ফাইল" },
                        { "text": "সংবেদনশীল ডেটা জিরো-নলেজ আর্কিটেকচার ব্যবহার করে প্রসেস করা হয়" },
                        { "text": "দৈনিক সিকিউরিটি লগ অডিট এবং ভালনারাবিলিটি স্ক্যান" },
                        { "text": "কর্মচারী অ্যাক্সেস সর্বনিম্ন বিশেষাধিকার নীতি অনুসারে" }
                    ]
                },
                {
                    "title": "৫. ডেটা শেয়ারিং",
                    "description": "আমরা আপনার ব্যক্তিগত তথ্য বিক্রি করি না। আমরা নিম্নলিখিত পক্ষের সাথে তথ্য শেয়ার করতে পারি:",
                    "items": [
                        { "bold": "পরিষেবা প্রদানকারী", "text": "শুধুমাত্র নির্দিষ্ট পরিষেবা প্রদানের জন্য প্রয়োজনীয় ডেটা প্রসেসিং-এর মধ্যে সীমাবদ্ধ (যেমন CloundFlare ক্লাউড স্টোরেজ, Creem/Stripe/PayPal ইত্যাদি তৃতীয় পক্ষের পেমেন্ট গেটওয়ে), এবং ডেটা প্রসেসিং চুক্তি স্বাক্ষর করতে হবে" },
                        { "bold": "আইনি প্রয়োজনীয়তা", "text": "যখন বৈধ সাবপিনা, আদালতের আদেশ, বা আমাদের প্রযোজ্য অন্য আইনি প্রক্রিয়া গ্রহণ করা হয়" }
                    ]
                },
                {
                    "title": "৬. আপনার অধিকার",
                    "description": "আপনার অঞ্চলের প্রযোজ্য আইন অনুসারে, আপনার নিম্নলিখিত অধিকার থাকতে পারে:",
                    "items": [
                        { "text": "আপনার ব্যক্তিগত ডেটার একটি কপি অ্যাক্সেস করা" },
                        { "text": "অসঠিক বা অসম্পূর্ণ তথ্য সংশোধন করা" },
                        { "text": "ডেটা মুছে ফেলার অধিকার ('ভুলে যাওয়ার অধিকার'), যদি না আমাদের রাখার একটি আইনি কারণ থাকে" },
                        { "text": "ডেটা প্রসেসিং-এর নির্দিষ্ট ধরন আপত্তি বা সীমিত করা" },
                        { "text": "ডেটা পোর্টেবিলিটির অধিকার, আপনি আপনার ডেটা স্থানান্তরের অনুরোধ করতে পারেন" }
                    ]
                },
                {
                    "title": "৭. শিশুদের গোপনীয়তা",
                    "description": "আমাদের পরিষেবা ১৬ বছরের কম বয়সী শিশুদের উদ্দেশ্যে নয়। জেনারেল ডেটা প্রোটেকশন রেগুলেশন (GDPR) এর আর্টিকেল ৮ অনুসারে, ১৬ বছরের কম বয়সী শিশুদের সম্মতি তাদের পিতামাতা বা অভিভাবক দ্বারা প্রদান করা আবশ্যক। যদি আপনি জানেন যে ১৬ বছরের কম বয়সী কোনো শিশু আমাদের কাছে ব্যক্তিগত তথ্য প্রদান করেছে, অনুগ্রহ করে অবিলম্বে clixmagicai@gmail.com-এ যোগাযোগ করুন।"
                },
                {
                    "title": "৮. এই নীতির পরিবর্তন",
                    "description": "আমরা নিয়মিতভাবে এই গোপনীয়তা নীতি আপডেট করতে পারি। আমরা এই পৃষ্ঠায় নতুন নীতি পোস্ট করা এবং \"সর্বশেষ আপডেট\" তারিখ আপডেট করা হবে।"
                },
                {
                    "title": "৯. যোগাযোগ করুন",
                    "description": "যদি আপনার এই গোপনীয়তা নীতি সম্পর্কে কোনো প্রশ্ন থাকে, অনুগ্রহ করে clixmagicai@gmail.com-এ যোগাযোগ করুন। আপনি যদি মনে করেন যে আপনার ডেটা অনুপযুক্তভাবে প্রসেস করা হয়েছে বা আপনার কোনো উদ্বেগ থাকে, আপনি যেকোনো সময় আমাদের সাথে যোগাযোগ করতে দ্বিধা করবেন না।"
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "১. কুকি কী",
                    "description": "কুকি হল ছোট টেক্সট ফাইল যা আপনি ওয়েবসাইট পরিদর্শন করার সময় আপনার কম্পিউটার বা মোবাইল ডিভাইসে রাখা হয়। এগুলি ওয়েবসাইটকে আপনার ডিভাইস চিনতে এবং আপনি আগে সাইটটি পরিদর্শন করেছেন কিনা তা মনে রাখতে অনুমতি দেয়।"
                },
                {
                    "title": "২. আমরা কীভাবে কুকি ব্যবহার করি",
                    "description": "ClixMagicAI বিভিন্ন উদ্দেশ্যে কুকি ব্যবহার করে:",
                    "items": [
                        { "bold": "প্রয়োজনীয় কুকি", "text": "আমাদের ওয়েবসাইটের মৌলিক ফাংশন (যেমন সেশন ম্যানেজমেন্ট এবং সিকিউরিটি ফিচার) এর জন্য প্রয়োজনীয়" },
                        { "bold": "পছন্দের কুকি", "text": "আপনার অভিজ্ঞতা বাড়াতে আপনার সেটিংস এবং পছন্দগুলি মনে রাখে, যেমন Google বা GitHub দিয়ে লগইন করার পর আপনার অবতার, ব্যবহারকারীর নাম ইত্যাদি মনে রাখা" },
                        { "bold": "বিশ্লেষণ কুকি", "text": "বেনামী তথ্য সংগ্রহ করে ভিজিটররা কীভাবে আমাদের ওয়েবসাইটের সাথে মিথস্ক্রিয়া করে তা বুঝতে সাহায্য করে" },
                        { "bold": "মার্কেটিং কুকি", "text": "আপনার ব্রাউজিং অভ্যাস ট্র্যাক করে আপনার আগ্রহ অনুযায়ী বিজ্ঞাপন প্রদান করে" }
                    ]
                },
                {
                    "title": "৩. আমরা যে ধরনের কুকি ব্যবহার করি",
                    "subsection": [
                        {
                            "title": "৩.১ প্রয়োজনীয় কুকি",
                            "description": "এই কুকিগুলি ওয়েবসাইটের সঠিক কার্যকারিতার জন্য আবশ্যক। এগুলি সিকিউরিটি, নেটওয়ার্ক ম্যানেজমেন্ট এবং অ্যাকাউন্ট অ্যাক্সেস (Google এবং GitHub লগইন সহ) এর মতো মূল ফাংশন সক্ষম করে। আপনি এই কুকিগুলি ব্লক করতে আপনার ব্রাউজার সেট করতে পারেন, তবে ওয়েবসাইটের কিছু অংশ সঠিকভাবে কাজ নাও করতে পারে।"
                        },
                        {
                            "title": "৩.২ পারফরম্যান্স এবং বিশ্লেষণ কুকি",
                            "description": "এই কুকিগুলি বেনামী তথ্য সংগ্রহ করে ভিজিটররা কীভাবে আমাদের ওয়েবসাইটের সাথে মিথস্ক্রিয়া করে তা বুঝতে সাহায্য করে। আমরা আমাদের ওয়েবসাইট এবং পরিষেবা উন্নত করতে এই ডেটা ব্যবহার করি। এই কুকিগুলি ভিজিটরদের শনাক্ত করতে পারে এমন তথ্য সংগ্রহ করতে না।"
                        },
                        {
                            "title": "৩.৩ ফাংশনালিটি কুকি",
                            "description": "এই কুকিগুলি আমাদের ওয়েবসাইটকে আপনি করা পছন্দগুলি (যেমন ভাষা পছন্দ বা লগইন স্ট্যাটাস) মনে রাখতে অনুমতি দেয় যাতে আরও উন্নত ব্যক্তিগতকৃত বৈশিষ্ট্য প্রদান করা যায়, যেমন Google বা GitHub দিয়ে আপনার লগইন স্ট্যাটাস মনে রাখা।"
                        },
                        {
                            "title": "৩.৪ টার্গেটিং এবং বিজ্ঞাপন কুকি",
                            "description": "এই কুকিগুলি ভিজিটরদের প্রাসঙ্গিক বিজ্ঞাপন দেখাতে এবং আমাদের বিজ্ঞাপন ক্যাম্পেইনের কার্যকারিতা ট্র্যাক করতে ব্যবহৃত হয়। অনুগ্রহ করে নোট করুন যে, যেহেতু আমাদের ওয়েবসাইট প্রাথমিকভাবে তৃতীয় পক্ষের লগইন (Google এবং GitHub) এর উপর নির্ভর করে, এই ধরনের কুকি প্রাথমিকভাবে ব্যবহারকারী অভিজ্ঞতা উন্নত করতে ব্যবহৃত হয়, সরাসরি মার্কেটিং এর জন্য নয়।"
                        }
                    ]
                },
                {
                    "title": "৪. কুকি ম্যানেজমেন্ট",
                    "description": "আপনি বিভিন্ন উপায়ে কুকি নিয়ন্ত্রণ এবং পরিচালনা করতে পারেন। বেশিরভাগ ওয়েব ব্রাউজার আপনাকে কুকি পছন্দ পরিচালনা করতে দেয়। আপনি পারিন:",
                    "items": [
                        { "text": "আপনার ডিভাইস থেকে কুকি মুছে ফেলতে" },
                        { "text": "কুকি ব্লক করতে, আপনার ব্রাউজারের সেটিংস সক্রিয় করে যা আপনাকে কিছু বা সমস্ত কুকি প্রত্যাখ্যান করতে দেয়" },
                        { "text": "কুকি প্রাপ্ত হলে আপনাকে সতর্ক করতে আপনার ব্রাউজার সেট করতে" }
                    ]
                },
                {
                    "title": "৫. তৃতীয় পক্ষের কুকি",
                    "description": "কিছু কুকি তৃতীয় পক্ষ দ্বারা আমাদের ওয়েবসাইটে রাখা হয়। এই তৃতীয় পক্ষগুলির মধ্যে বিশ্লেষণ পরিষেবা (যেমন Google Analytics) এবং বিজ্ঞাপন নেটওয়ার্ক থাকতে পারে। কুকি কীভাবে কাজ করে (কুকি শুধুমাত্র যারা প্রথমে সেগুলি সেট করেছেন তাদের দ্বারা অ্যাক্সেস করা যাবে) তার কারণে, আমরা এই তৃতীয় পক্ষগুলির কুকিগুলির ব্যবহার নিয়ন্ত্রণ করি না এবং সেগুলি অ্যাক্সেস করতে পারি না। Google এবং GitHub দিয়ে লগইন করা ব্যবহারকারীদের জন্য, সংশ্লিষ্ট তথ্য পরিচালনা করার সময় আমরা এই প্ল্যাটফর্মগুলির গোপনীয়তা নির্দেশিকা মেনে চলব।"
                },
                {
                    "title": "৬. এই কুকি নীতির আপডেট",
                    "description": "আমরা সময়ে সময়ে এই কুকি নীতি আপডেট করতে পারি, প্রযুক্তি, নিয়ন্ত্রণ বা আমাদের ব্যবসার অভ্যাসে পরিবর্তন প্রতিফলিত করতে। যেকোনো পরিবর্তন এই পৃষ্ঠায় পোস্ট করা হবে এবং সংশোধন তারিখ আপডেট করা হবে।"
                },
                {
                    "title": "৭. যোগাযোগ করুন",
                    "description": "আমাদের কুকি ব্যবহার সম্পর্কে আপনার কোনো প্রশ্ন থাকলে, অনুগ্রহ করে clixmagicai@gmail.com-এ যোগাযোগ করুন।"
                }
            ]
        }
    },
    UserFeedback: {
        title: "ব্যবহারকারীদের মতামত",
        feedback: "আমাদের AI ছবি প্রক্রিয়াকরণ প্রযুক্তি সম্পর্কে বিশ্বব্যাপী সৃজনশীল ও পেশাদার ব্যক্তিদের থেকে প্রকৃত মূল্যায়ন শুনুন।",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "জনাব লিন",
                profession: "ভিডিও সম্পাদক ও মিডিয়া কনটেন্ট ক্রিয়েটর",
                rating: 5,
                comment: "অসাধারণ! ClixMagicAI খুব দ্রুত কাজ করে! ওয়াটারমার্ক সহ ভিডিও আপলোড করুন, কয়েক মিনিটেই ওয়াটারমার্ক ছাড়া ভার্সন পাবেন, ছবির মান একদম নষ্ট হয় না। ওয়াটারমার্ক অপসারণের জন্য অপরিহার্য টুল!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "জনাবা সু",
                profession: "সোশ্যাল মিডিয়া বিশেষজ্ঞ",
                rating: 5,
                comment: "ClixMagicAI আমার Ins মেটেরিয়াল লাইব্রেরি বাঁচিয়েছে! জটিল ওয়াটারমার্কও সঠিকভাবে চিহ্নিত করতে পারে, প্রান্তগুলো আমার আগে ব্যবহৃত সফটওয়্যারের তুলনায় অনেক সূক্ষ্মভাবে প্রক্রিয়া করে, যা ভিজ্যুয়াল ইফেক্ট আরও স্বাভাবিক করে তোলে।"
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "জনাব চেন",
                profession: "শর্ট ভিডিও কনটেন্ট নির্মাতা",
                rating: 5,
                comment: "ClixMagicAI দিয়ে ওয়াটারমার্ক অপসারণ খুব সহজ, যাতায়াতের সময়ে TikTok মেটেরিয়াল প্রসেস করি, অফিসে গিয়ে সরাসরি হাই রেজোলিউশন ভার্সন ডাউনলোড করি, দক্ষতা দ্বিগুণ হয়েছে! মিডিয়া কর্মীদের জন্য বরদান।"
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "জনাব হুয়াং",
                profession: "গ্রাফিক ডিজাইনার ও ভিজ্যুয়াল ক্রিয়েটিভ ডিরেক্টর",
                rating: 5,
                comment: "একজন ডিজাইনার হিসেবে আমি খুব সন্তুষ্ট! ক্লায়েন্টের প্রদত্ত লোগো সম্বলিত ছবি প্রসেস করার সময়, ব্যাকগ্রাউন্ড টেক্সচার খুব স্বাভাবিকভাবে পুনরুদ্ধার হয়, PS এর কোনো চিহ্ন নেই, পোস্ট-প্রসেসিং সময় অনেক বাঁচে।"
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "জনাবা এমিলি",
                profession: "ফ্রিল্যান্স ডিজিটাল কনটেন্ট ক্রিয়েটর",
                rating: 5,
                comment: "সত্যিকারের খাজানা পেয়েছি! সদস্যতা মূল্য বাজারের অন্যান্য ওয়াটারমার্ক অপসারণ পণ্যের তুলনায় অনেক কম, কিন্তু ওয়াটারমার্ক অপসারণের ফলাফল আরও ভাল, বিশেষত গ্রেডিয়েন্ট স্বচ্ছ ওয়াটারমার্ক প্রসেস করার সময় সুবিধা স্পষ্ট।"
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "জনাব রবার্টসন",
                profession: "কর্পোরেট প্রশিক্ষণ কোর্স নির্মাতা",
                rating: 5,
                comment: "ClixMagicAI ইনস্টল না করেই ব্যবহার করা যায়, খুব সুবিধাজনক! অফিসের কম্পিউটারে অনুমতি সীমিত থাকায় সফটওয়্যার ইনস্টল করা যায় না, এখন ব্রাউজার দিয়েই কোর্স মেটেরিয়াল প্রসেস করতে পারি, যেকোনো সময় যেকোনো জায়গা থেকে।"
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "জনাবা ঝাও",
                profession: "গৃহিণী ও কমিউনিটি ছবি সম্পাদক",
                rating: 5,
                comment: "ইন্টারফেস এতই সহজ যে দাদিমাও ব্যবহার করতে পারবেন! PS মতো পেশাদার সফটওয়্যার শেখার সময় নেই যাদের, তারা অবশ্যই ClixMagicAI চেষ্টা করে দেখুন, আমার মতো টেকনিক্যাল নবিসদের জন্য খুব উপযুক্ত। হাহা~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "জনাব জনসন",
                profession: "ই-কমার্স ভিজ্যুয়াল প্ল্যানার",
                rating: 5,
                comment: "ClixMagicAI অত্যন্ত শক্তিশালী, ছবি, ভিডিও, ছোট বস্তু, পথচারী, টেক্সট ইত্যাদি অপসারণ করতে পারে, ফিচার সম্পূর্ণ, সবাইকে সুপারিশ করছি~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "জনাবা ফাং",
                profession: "ফটোগ্রাফি শখের ও অনলাইন কনটেন্ট শেয়ারকারী",
                rating: 5,
                comment: "ওয়াও~ অবশেষে একটি ওয়াটারমার্ক অপসারণ টুল পেয়েছি যা ছবির মান নষ্ট করে না! যাদুর মতো আশ্চর্যজনক~ ছবি সম্পাদনা আর সমস্যা নয়! জোরালোভাবে সুপারিশ করছি!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "জনাব উইলিয়ামস",
                profession: "অনলাইন শিক্ষা প্রশিক্ষক",
                rating: 5,
                comment: "ওয়াটারমার্ক অবস্থান মনে রাখার ফিচারটি অত্যন্ত কার্যকর! সিরিজ কোর্স ভিডিও প্রসেস করার সময় বারবার এলাকা নির্বাচন করতে হয় না, কমপক্ষে আধঘণ্টা কাজের সময় বাঁচে, আমার শিক্ষা প্রস্তুতির দক্ষতা অনেক বাড়িয়েছে।"
            }
        ]
    },
    FAQ: {
        title: "ClixMagicAI ব্যবহার গাইড এবং সাধারণ প্রশ্নাবলী",
        prompt: "কোন সমস্যা বা প্রশ্ন আছে? যেকোনো সময় আমাদের সাথে যোগাযোগ করুন: clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "ClixMagicAI কী এবং এটি কীভাবে কাজ করে?",
                answer: "ClixMagicAI হল একটি উন্নত AI-চালিত ওয়াটারমার্ক অপসারণ টুল। এটি ছবি এবং ভিডিওতে ওয়াটারমার্ক স্বয়ংক্রিয়ভাবে সনাক্ত করে এবং ম্যানুয়ালি ওয়াটারমার্ক অবস্থান চিহ্নিত করার বৈশিষ্ট্য প্রদান করে। ছবির জন্য, এটি বিভিন্ন ফরম্যাট রূপান্তর সমর্থন করে এবং উচ্চ মানের আউটপুট নিশ্চিত করে; ভিডিওর জন্য, এটি স্থির, গতিশীল এমনকি আকার পরিবর্তনশীল ওয়াটারমার্ক প্রক্রিয়া করতে পারে।"
            },
            {
                id : 2,
                question: "ClixMagicAI কি বিনামূল্যে ব্যবহার প্রদান করে?",
                answer: "হ্যাঁ, আমরা প্রতিদিন ১০ পয়েন্টের একটি বেসিক ফ্রি সার্ভিস প্রদান করি! আপনি এটি ছবি প্রক্রিয়া করতে (প্রতিবার 1 পয়েন্ট ব্যয়) বা ভিডিও (প্রতিবার 3 পয়েন্ট ব্যয়) ব্যবহার করতে পারেন। বর্তমানে অতিরিক্ত পয়েন্ট কেনার সুবিধা নেই, শুধুমাত্র প্রতিদিনের ফ্রি ১০ পয়েন্টই পাওয়া যাবে।"
            },
            {
                id : 3,
                question: "আমি কি অতিরিক্ত পয়েন্ট কিনতে পারি?",
                answer: "বর্তমানে অতিরিক্ত পয়েন্ট কেনার সুবিধা নেই। প্রতিটি ব্যবহারকারী প্রতিদিন শুধুমাত্র ১০টি ফ্রি পয়েন্ট পাবেন, যা পরের দিন স্বয়ংক্রিয়ভাবে রিফ্রেশ হবে।"
            },
            {
                id : 4,
                question: "কোন ফাইল ফরম্যাট সমর্থিত?",
                answer: "ছবির জন্য, আমরা PNG, JPEG, JPG, WEBP, HEIC এবং HEIF ফরম্যাট সমর্থন করি, যেখানে HEIC এবং HEIF স্বয়ংক্রিয়ভাবে PNG-তে রূপান্তরিত হবে। ভিডিওর জন্য, আমরা MP4, MOV সহ বিভিন্ন ফরম্যাট সমর্থন করি।"
            },
            {
                id : 5,
                question: "আমার গোপনীয়তা কীভাবে রক্ষা করা হয়?",
                answer: "ClixMagicAI-এ, আমরা ব্যবহারকারীর গোপনীয়তাকে অত্যন্ত গুরুত্ব দিই। সমস্ত আপলোড করা ফাইল এনক্রিপ্ট করা হবে এবং প্রক্রিয়া সম্পন্ন হওয়ার 24 ঘন্টার মধ্যে স্বয়ংক্রিয়ভাবে মুছে ফেলা হবে। আমরা কোনও ব্যবহারকারী ফাইল বা সম্পর্কিত তথ্য সংরক্ষণ করি না।"
            },
            {
                id : 6,
                question: "আমি কীভাবে ClixMagicAI-এ লগইন করতে পারি?",
                answer: "আমরা GitHub বা Google অ্যাকাউন্টের মাধ্যমে দ্রুত লগইন সমর্থন করি, যা আপনার অ্যাকাউন্টের সুরক্ষা নিশ্চিত করে এবং নিবন্ধন প্রক্রিয়া সরল করে।"
            },
            {
                id : 7,
                question: "প্রক্রিয়াকরণ কতটা দ্রুত?",
                answer: "আমাদের উচ্চ-কর্মক্ষমতার সার্ভার এবং অপ্টিমাইজড AI অ্যালগরিদমের কারণে, বেশিরভাগ ছবি ওয়াটারমার্ক অপসারণ কাজ 10 সেকেন্ডের মধ্যে সম্পন্ন করা যেতে পারে, আর ভিডিও ওয়াটারমার্ক অপসারণ সবচেয়ে দ্রুত মাত্র 1 মিনিট লাগতে পারে। প্রকৃত সময় ফাইলের আকার এবং জটিলতার উপর নির্ভর করে পরিবর্তিত হতে পারে।"
            },
            {
                id : 8,
                question: "প্রক্রিয়াকরণের পরে ফলাফল কেমন হবে?",
                answer: "আমাদের AI মডেলগুলি ব্যাপকভাবে প্রশিক্ষিত, এবং মূল সামগ্রীর মান বজায় রেখে বুদ্ধিমত্তার সাথে ছবি এবং ভিডিও থেকে ওয়াটারমার্ক অপসারণ করতে পারে। স্বয়ংক্রিয়ভাবে সনাক্ত করা হোক বা ম্যানুয়ালি চিহ্নিত করা হোক, ওয়াটারমার্কগুলি কার্যকরভাবে অপসারণ করা যেতে পারে, যা নিশ্চিত করে যে চূড়ান্ত ফলাফল প্রাকৃতিক এবং চিহ্নবিহীন।"
            },
            {
                id : 9,
                question: "প্রতিটি কাজের মেয়াদ কত দিন?",
                answer: "একবার কাজ সম্পন্ন হলে, প্রক্রিয়াজাত ফাইলগুলি ডাউনলোডের জন্য ClixMagicAI-এ 24 ঘন্টা রাখা হবে। মেয়াদ শেষ হওয়ার পরে, ফাইলগুলি আপনার গোপনীয়তা রক্ষার জন্য আমাদের সার্ভার থেকে স্বয়ংক্রিয়ভাবে মুছে ফেলা হবে।"
            },
            {
                id : 10,
                question: "সর্বাধিক ফাইল আকারের সীমা কত?",
                answer: "আমরা সর্বাধিক 10MB ছবি ফাইল এবং সর্বাধিক 100MB ভিডিও ফাইল গ্রহণ করি। এই সীমা ছাড়িয়ে গেলে ফাইলগুলি আপলোড করার আগে সম্ভবত সংকুচিত বা ক্রপ করতে হবে।"
            }
        ]
    },
}